<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dati Identificativi</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-select
                          :name="beForm[rep].insurer_id.label"
                          vid="insurer_id"
                          :label="beForm[rep].insurer_id.label"
                          v-model="form[rep].insurer_id"
                          :options="companies"
                          @input="onInputInsurer"
                          :rules="getRules('insurer_id')"
                          :disabled="
                          companies.find(
                            (company) => company.value == form[rep].insurer_id
                          ).importer_id
                            ? true
                            : false
                        "
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          :name="beForm[rep].risk_branch_id.label"
                          vid="risk_branch_id"
                          :label="beForm[rep].risk_branch_id.label"
                          v-model="form[rep].risk_branch_id"
                          :options="risk_branches"
                          :rules="getRules('risk_branch_id')"
                          :disabled="
                          companies.find(
                            (company) => company.value == form[rep].insurer_id
                          ).importer_id
                            ? true
                            : false
                        "
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].code.label"
                          vid="code"
                          label="Codice rischio"
                          v-model="form[rep].code"
                          placeholder="Inserisci un codice"
                          :rules="getRules('code')"
                          :readonly="
                          companies.find(
                            (company) => company.value == form[rep].insurer_id
                          ).importer_id
                            ? true
                            : false
                        "
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].title.label"
                          vid="title"
                          :label="beForm[rep].title.label"
                          v-model="form[rep].title"
                          placeholder="Inserisci una descrizione"
                          :rules="getRules('title')"
                          :readonly="
                          companies.find(
                            (company) => company.value == form[rep].insurer_id
                          ).importer_id
                            ? true
                            : false
                        "
                        />
                      </div>
                      <div class="form-group">
                        <base-select
                          vid="delay_days"
                          :name="beForm[rep].delay_days.label"
                          :label="beForm[rep].delay_days.label"
                          v-model="form[rep].delay_days"
                          :options="beForm[rep].delay_days.options"
                          :rules="getRules('delay_days')"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>

              <div class="mt-2" v-show="customInputs[rep].length">
                <div class="form-card-wrapper">
                  <b-card header-tag="header">
                    <template #header>
                      <b>Attributi personalizzati</b>
                    </template>
                    <b-card-text>
                      <custom-inputs
                        :customInputs="customInputs[rep]"
                        v-model="form[rep]"
                        :beForm="beForm[rep]"
                        :beRules="beRules[rep]"
                      />
                    </b-card-text>
                  </b-card>
                </div>
              </div>

              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="handleSubmit(onSubmit)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left
                      >
                      Torna indietro
                    </b-button
                    >
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import CustomInputs from "@/components/form/CustomInputs";
import BaseInput from "@/components/form/BaseInput";
import BaseSelect from "@/components/form/BaseSelect";
import FormMixin from "@/mixins/FormMixin";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import {mapGetters} from "vuex";

export default {
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "insurance_risk",
      id: this.$route.params.id,
      companies: [],
      risk_branches: [],
      risks: [],
      form: {
        risk_type_id: null,
        insurance_risk: {
          code: null,
          insurer_id: null,
          risk_branch_id: null,
          title: null,
        },
      },
    };
  },
  components: {
    CustomInputs,
    BaseInput,
    BaseSelect,
  },
  methods: {
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "profile-insurance-risks-edit":
            this.$router.push({
              name: "insurance_risks.edit",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    onSubmit() {
      this.isLoading = true;
      this.update(this.repository, this.id)
        .then(() => {
          this.$store.dispatch("auth/products");
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Prodotto Modificato`,
          });
          this.shortcut(
            "module.PROF",
            null,
            "#InsurerRisks",
            "filterInsuranceRisks"
          );
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onInputInsurer(insurer) {
      this.form[this.rep].insurer_id = insurer;
      this.form[this.rep].risk_branch_id = null;
      this.form.risk_type_id = null;
      this.risk_branches = this.getBranches()(insurer);
    },
    ...mapGetters("auth", {
      getRisks: "risks",
      getBranches: "branches",
      getInsurers: "insurers",
    }),
  },
  beforeMount() {
    this.isLoading = true;
    this.fetchEditForm(this.repository, this.id).then(() => {
      this.companies = this.getInsurers();
      console.log("Insurers: ", this.companies);
      this.risk_branches = this.getBranches()();
      this.risks = this.getRisks();
      this.isLoading = false;
    });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
